import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_SL_Header, Component_SL_Icon } from '@app/styles/skeleton-loaders';
import { LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_Notes.scss';
export const Component_SL_Note = () => {
    return _jsxs(LL_H_C, { className: 'c-asl-note', children: [_jsx(Component_SL_Icon, { variant: 'square', width: 30 }), _jsx(Component_SL_Header, { withSubtitle: true }), _jsx(Component_SL_Icon, { variant: 'round', width: 16 })] });
};
export const Component_AdvisorSL_Notes = () => {
    return _jsxs(LL_V_L, { className: 'c-asl-notes', children: [_jsx(Component_SL_Note, {}), _jsx(Component_SL_Note, {}), _jsx(Component_SL_Note, {}), _jsx(Component_SL_Note, {})] });
};
//# sourceMappingURL=Component_AdvisorSL_Notes.js.map